export default __webpack_public_path__ + "static/lp-ba-transparent-61f1ed078f3653f5a272f52f39e5e48a.png";